<script lang="ts" context="module">
  import Otrivinie from "../../../Images/OtrivinChatbot/otrivinie.png"; // Base image

  // Product Images
  import OtrivinDuo from "../../../Images/OtrivinChatbot/Otrivin_Duo_Packshot.jpeg";
  import OtrivinMenthol from "../../../Images/OtrivinChatbot/Otrivin_Menthol_Packshot.jpeg";
  import Otrivin01 from "../../../Images/OtrivinChatbot/Otrivin_0,1%_Packshot.jpeg";
  import Otrivin005 from "../../../Images/OtrivinChatbot/Otrivin_0,05%_Packshot.jpeg";
  import OtrivinTropfen from "../../../Images/OtrivinChatbot/Otrivin_Tropfen_Packshot.jpeg";
  import OtrivinNasengel from "../../../Images/OtrivinChatbot/otrivin-nasengel.png";
  // import OtrivinBaby from "../../../Images/OtrivinChatbot/.png";
  import OtrivinBabyWrong from "../../../Images/OtrivinChatbot/otrivin-natural-baby-100ml.png";
  import OtrivinIsotonSanft from "../../../Images/OtrivinChatbot/otrivin-natural-sanft-125ml.png";
  import OtrivinIsotonPflege from "../../../Images/OtrivinChatbot/otrivin-natural-pflege-30ml.png";
  import OtrivinIsotonStrahl from "../../../Images/OtrivinChatbot/otrivin-natural-125ml.png";
  import OtrivinHyperton from "../../../Images/OtrivinChatbot/otrivin-natural-30ml.png";
  import Vibrocil from "../../../Images/OtrivinChatbot/vibrocil-headerpackshots.jpg";

  const idToImgMap = new Map([
    ["otrivin-duo", OtrivinDuo],
    ["otrivin-menthol", OtrivinMenthol],
    ["otrivin-0.1", Otrivin01],
    ["otrivin-0.05", Otrivin005],
    ["otrivin-tropfen", OtrivinTropfen],
    ["otrivin-nasengel", OtrivinNasengel],
    ["otrivin-baby", OtrivinBabyWrong],
    ["otrivin-isoton-sanft", OtrivinIsotonSanft],
    ["otrivin-nasen-saft", OtrivinIsotonSanft],
    ["otrivin-isoton-pflege", OtrivinIsotonSanft],
    ["otrivin-isoton-strahl", OtrivinIsotonStrahl],
    ["otrivin-hyperton", OtrivinHyperton],
    ["vibrocil", Vibrocil],
    ["otrivin-nasen-pflege", OtrivinIsotonPflege],
    ["otrivin-nasen-spray", OtrivinHyperton],
    ["otrivin-nasen-reinigung", OtrivinIsotonStrahl],
  ]);
</script>

<script lang="ts">
  import type { Products } from "../../types/OtrivinChatbot";
  import type { Product } from "../../types/OtrivinChatbot";
  import type { QuestionMap } from "../../types/OtrivinChatbot";
  import type { Question } from "../../types/OtrivinChatbot";
  import type { Answer } from "../../types/OtrivinChatbot";
  import Icon from "../UI/Icon.svelte";

  export let productsData: string;
  let products: Products = JSON.parse(productsData);

  const questions: QuestionMap = new Map([
    [
      -1,
      {
        questionText:
          "<p> Hallo, ich bin <strong>Otrivinie</strong>, und ich helfe Ihnen, die passende Lösung für Ihren Schnupfen und Ihre Allergie zu finden.</br> Bitte beantworten Sie die folgenden Fragen, um Unterstützung bei der Wahl des passenden Produkts (<em>Nasenspray, Nasentropfen, Nasenspülungen</em> oder <em>Gel</em>) der Marke <strong>Otrivin</strong> zu erhalten.</p>",
        answers: [
          {
            text: "Start",
            followupQuestionId: 0,
          },
        ],
      },
    ],
    [
      0,
      {
        questionText:
          "Brauchen Sie das Otrivin Produkt für sich selbst oder für Ihre Kinder?",
        answers: [
          {
            text: "Für mich selbst",
            followupQuestionId: 1,
          },
          {
            text: "Für mein Kind",
            followupQuestionId: 2,
          },
        ],
      },
    ],
    [
      1,
      {
        questionText: "Haben Sie derzeit eine verstopfte Nase?",
        answers: [
          {
            text: "Ja",
            followupQuestionId: 3,
          },
          {
            text: "Nein",
            deadEnd: `
              <p>Freies Atmen ist wichtig für ein gesundes Leben. Schützen Sie Ihre Nasengesundheit mit unserem neuen Produkt: Otrivin Natural. Es hilft Ihnen, Ihre Atemwege zu pflegen und immer frei durchzuatmen.</p> `,
            href: "/social-videos/otrivin-natrural",
          },
        ],
      },
    ],
    [
      2,
      {
        questionText:
          "Hat Ihr Kind derzeit verstopfte Nase wegen einer Erkältung?",
        answers: [
          {
            text: "Ja",
            followupQuestionId: 9,
          },
          {
            text: "Nein, ich brauche Otrivin für die tägliche Pflege",
            followupQuestionId: 12,
          },
        ],
      },
    ],
    [
      3,
      {
        questionText: "Haben Sie eine verstopfte Nase wegen einer Erkältung?",
        answers: [
          {
            text: "Ja",
            followupQuestionId: 4,
          },
          {
            text: "Nein",
            followupQuestionId: 6,
          },
        ],
      },
    ],
    [
      4,
      {
        questionText:
          "Leiden Sie zusätzlich zur verstopften Nase auch unter einer rinnenden Nase?",
        answers: [
          {
            text: "Ja",
            productIds: ["otrivin-duo"],
          },
          {
            text: "Nein",
            followupQuestionId: 5,
          },
        ],
      },
    ],
    [
      5,
      {
        questionText:
          "Bevorzugen Sie bei Ihrer verstopften Nase einen Nasenspray mit Menthol oder ein neutrales Produkt (ohne Aroma)?",
        answers: [
          {
            text: "Menthol",
            productIds: ["otrivin-menthol"],
          },
          {
            text: "Neutral",
            productIds: ["otrivin-0.1", "otrivin-nasengel"],
          },
        ],
      },
    ],
    [
      6,
      {
        questionText:
          "Benötigen Sie das Produkt gegen verstopfte Nase für die tägliche Hygiene oder zur gelegentlichen Allergiebehandlung?",
        answers: [
          {
            text: "Tägliche Hygiene",
            followupQuestionId: 7,
          },
          {
            text: "Allergiebehandlung",
            followupQuestionId: 11,
          },
        ],
      },
    ],
    [
      7,
      {
        questionText: "Welche Darreichungsform bevorzugen Sie?",
        answers: [
          {
            text: "Nasenspray",
            followupQuestionId: 8,
          },
          {
            text: "Nasenspülung",
            followupQuestionId: 10,
          },
        ],
      },
    ],
    [
      8,
      {
        questionText:
          "Soll der Nasenspray zur täglichen Verwendung zusätzlich leicht abschwellend wirken?",
        answers: [
          {
            text: "Ja",
            productIds: ["otrivin-nasen-spray"],
          },
          {
            text: "Nein",
            productIds: ["otrivin-nasen-pflege"],
          },
        ],
      },
    ],
    [
      9,
      {
        questionText: "Welche Darreichungsform bevorzugen Sie für Ihr Kind?",
        answers: [
          {
            text: "Tropfen",
            productIds: ["otrivin-tropfen"],
          },
          {
            text: "Spray",
            productIds: ["otrivin-0.05"],
          },
        ],
      },
    ],
    [
      10,
      {
        questionText:
          "Bevorzugen Sie eine sanfte Befeuchtung der Nase oder eine Reinigung mittels Sprühstrahl?",
        answers: [
          {
            text: "Sanfte Befeuchtung",
            productIds: ["otrivin-isoton-sanft"],
          },
          {
            text: "Reinigung mit Sprühstrahl",
            productIds: ["otrivin-isoton-strahl"],
          },
        ],
      },
    ],
    [
      11,
      {
        questionText:
          "Benötigen Sie eine wirkstoffhaltige oder eine natürliche Lösung, um allergischen Schnupfen zu bekämpfen?",
        answers: [
          {
            text: "Natürliche Lösung",
            followupQuestionId: 7,
          },
          {
            text: "Wirkstoffhaltige Lösung",
            productIds: ["vibrocil"],
          },
        ],
      },
    ],
    [
      12,
      {
        questionText: "Wie alt ist ihr Kind?",
        answers: [
          {
            text: "Baby (0-2 Jahren)",
            productIds: ["otrivin-baby"],
          },
          {
            text: "Kleinkind (2-6 Jahren)",
            productIds: ["otrivin-nasen-saft", "otrivin-nasen-pflege"],
          },
          {
            text: "Kind (ab 6 Jahren)",
            productIds: ["otrivin-nasen-spray", "otrivin-nasen-reinigung"],
            // maybe new?
            //productIds: ["otrivin-hyperton", "otrivin-isoton-strahl"],
          },
        ],
      },
    ],
  ]);

  let currentQuestion: Question = questions.get(-1);
  let currentProducts: [string, Product][];
  let isSplitProducts: boolean;

  let deadEnd = {
    //todo: logo austauschen halbe stunde aufwand wenns des welln
    bool: false,
    text: "",
    href: "",
  };

  let counter = 1;
  let isOpenPopup = false;

  const toggleChatbot = () => {
    isOpenPopup = !isOpenPopup;

    if (!isOpenPopup) {
      setTimeout(() => {
        resetChatbot();
      }, 200);
    }
  };

  const resetChatbot = () => {
    currentQuestion = questions.get(-1);
    currentProducts = null;
    counter = 1;
    isSplitProducts = undefined;
  };

  let history: (Question | undefined)[] = [];

  const optionClicked = (answer: Answer) => {
    history.push(currentQuestion); // Track current question

    if ("followupQuestionId" in answer) {
      currentQuestion = questions.get(answer.followupQuestionId);
      currentProducts = undefined;
      deadEnd.bool = false;
      counter++;
    } else if ("productIds" in answer) {
      const productIds = answer.productIds;
      currentProducts = productIds
        .map((id) => [id, products[id]])
        .filter((tuple) => tuple[1]) as [string, Product][];
      isSplitProducts = currentProducts.length > 1;

      currentQuestion = undefined;
      deadEnd.bool = false;
    } else if ("deadEnd" in answer) {
      deadEnd.bool = true;
      deadEnd.text = answer.deadEnd;
      deadEnd.href = answer.href ?? "";

      currentQuestion = undefined;
      currentProducts = undefined;
    } else {
      console.error("No value in clicked answer!");
    }
  };

  const goBack = () => {
    if (history.length > 0) {
      const prev = history.pop();

      // Reset all output states
      currentQuestion = prev;
      currentProducts = undefined;
      deadEnd.bool = false;

      if (counter > 1) counter--;
    }
  };
</script>

<button
  class="otrivin-chatbot__toggle"
  class:open={isOpenPopup}
  on:click={toggleChatbot}
  tabindex="0"
>
  <Icon icon={isOpenPopup ? "\\f00d" : "\\3f"} />
</button>

<div class="otrivin-chatbot__popup" class:open={isOpenPopup}>
  <div class="otrivin-chatbot__content" class:wide={isSplitProducts}>
    <button
      class="otrivin-chatbot__close"
      on:click={toggleChatbot}
      tabindex="0"
    >
      <Icon icon="\f00d" />
    </button>
    {#if isSplitProducts}
      <!-- This block can be left empty or filled in as needed -->
    {:else}
      <div class="chatbot-image">
        <img
          src={currentProducts && currentProducts.length > 0
            ? idToImgMap.get(currentProducts[0][0])
            : Otrivinie}
          alt={currentProducts && currentProducts.length > 0
            ? currentProducts[0][1].title
            : "Otrivinie"}
        />
      </div>
    {/if}
    <div class="chatbot-content">
      {#if currentQuestion}
        <div class="chatbot-pagination">{counter}</div>
        <p class="chatbot-question">{@html currentQuestion.questionText}</p>
        <div class="chatbot-options">
          {#each currentQuestion.answers as ans, index}
            <button
              class={`chatbot-option-${index}`}
              on:click={() => optionClicked(ans)}
            >
              {ans.text}
            </button>
          {/each}
        </div>
        {#if counter > 1}
          <button class="chatbot-back" on:click={goBack}> ← Zurück </button>
        {/if}
      {:else if currentProducts && currentProducts.length > 0}
        {#if isSplitProducts}
          <p class="split-product__title">
            Unsere <b>Empfehlungen:</b>
          </p>
          <div class="split-product__container">
            {#each currentProducts as productTuple}
              <div class="split-product__item">
                <div class="chatbot-image">
                  <img
                    src={idToImgMap.get(productTuple[0])}
                    alt={productTuple[1].title}
                  />
                </div>
                <h3 class="chatbot-product__title">{productTuple[1].title}</h3>
                <div class="chatbot-product__description">
                  {@html productTuple[1].description}
                </div>
                <a class="chatbot-product__button" href={productTuple[1].href}>
                  Jetzt bestellen
                </a>
              </div>
            {/each}
          </div>
        {:else}
          <p class="chatbot-product__title">
            Unsere <b>Empfehlung:</b>
          </p>
          {#each currentProducts as productTuple}
            <!-- <img
              src={idToImgMap.get(productTuple[0])}
              alt={productTuple[1].title}
            /> -->
            <h3 class="chatbot-product__title">{productTuple[1].title}</h3>
            <div class="chatbot-product__description">
              {@html productTuple[1].description}
            </div>
            <a class="chatbot-product__button" href={productTuple[1].href}>
              Jetzt bestellen
            </a>
          {/each}
        {/if}
      {:else if deadEnd.bool}
        <p class="chatbot-dead-end__text">{@html deadEnd.text}</p>
        <a class="chatbot-dead-end__button" href={deadEnd.href}>Mehr erfahren</a
        >
      {/if}
    </div>
  </div>
</div>

<!-- TODO: responsive styles -->
<style lang="postcss">
  .otrivin-chatbot {
    text-align: center;
    &__toggle {
      position: fixed;
      bottom: 20px;
      right: 20px;
      background-color: var(--clr-secondary);
      border-radius: 50%;
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      z-index: 10000;
      border: none;
      :global(i) {
        font-size: 34px;
        color: white;
      }
      &.open {
        @media (max-width: 630px) {
          display: none;
        }
      }
    }
    &__close {
      display: none;
      @media (max-width: 630px) {
        display: block;
        border: none;
        background-color: transparent;
        position: absolute;
        top: 30px;
        right: 30px;
        cursor: pointer;
        :global(i) {
          font-size: 26px;
        }
      }
    }
    &__icon {
      width: 50%;
      filter: brightness(0) invert(1);
    }
    &__popup {
      position: fixed;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.4);
      opacity: 0;
      visibility: hidden;
      transition: 200ms ease;
      z-index: 9999;
      @media (max-width: 630px) {
        display: flex;
        padding: 15px;
        align-items: flex-end;
      }
      &.open {
        opacity: 1;
        visibility: visible;
      }
    }
    &__content {
      position: absolute;
      bottom: 80px;
      right: 80px;
      width: 400px;
      padding: 30px 30px;
      background-color: var(--clr-white);
      border-radius: 40px;
      border-bottom-right-radius: 0;
      border: 2px solid var(--clr-secondary);
      display: flex;
      flex-direction: column;
      max-height: 80vh;
      height: 650px;
      max-width: 70vw;
      &.wide {
        height: 700px;
        width: 650px;
      }
      @media (max-width: 630px) {
        max-height: 100dvh;
      }
      @media (max-width: 630px) {
        position: relative;
        width: 100%;
        max-width: 100%;
        max-height: 100vh;
        max-height: 100dvh;
        border-radius: 12px;
        right: unset;
        bottom: unset;
        overflow: auto;
      }
      .split-product__container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 30px;
        @media (max-width: 630px) {
          gap: 0;
        }
      }
      .split-product__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        max-height: 600px;
        /* .chatbot-image {
          height: 40%;
        } */
      }
    }
  }

  .chatbot-image {
    height: 250px;
    width: 100%;
    display: flex;
    justify-content: center;
    @media (max-width: 630px) {
      width: 100%;
      align-self: center;
      max-width: 280px;
      hyphens: auto;
      max-height: 300px;
    }
    img {
      height: 100%;
      max-width: 100%;
      object-fit: contain;
      @media (max-width: 630px) {
        height: 200px;
        width: 100%;
      }
    }
  }
  .chatbot-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .chatbot-pagination {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color: var(--clr-secondary);
    color: var(--clr-white);
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .chatbot-question {
    text-align: center;
  }
  .chatbot-back {
    background: none;
    border: none;
    color: var(--clr-primary);
    font-weight: 600;
    font-size: 0.9rem;
    margin: 2rem 0 0 0;
    cursor: pointer;
    text-align: left;
  }

  .chatbot-back:hover {
    text-decoration: underline;
  }
  .chatbot-options {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;
  }
  .chatbot-product__title {
    text-align: center;
  }
  [class^="chatbot-option-"],
  .chatbot-product__button,
  .chatbot-dead-end__button {
    padding: 4px 8px;
    background-color: var(--clr-primary);
    color: var(--clr-white);
    font-size: var(--fs-button);
    font-weight: normal;
    text-decoration: none;
    font-family: inherit;
    border: none;
    padding: 10px 20px;
    transition: var(--transition-duration) ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  body.no-scroll {
    overflow: hidden;
  }
</style>
